import React, { useEffect } from 'react';
import {  useLocation } from 'react-router-dom'
import ReactGA from "react-ga4";

export interface GAProps {
}

const GA: React.FC<GAProps> = (props) => {
    const location = useLocation()

    useEffect(
      () => {
        // ga.send(['pageview', location.pathname])

        ReactGA.send({ hitType: "pageview", page: location.pathname });
      },
      [location]
    )

    return null
}

export default GA;